import SkeletonList from './SkeletonList'

export default SkeletonList
